<template>
  <div ref="errorContainer" class="error-container pl-3 py-2">
    <div class="d-flex">
      <span class="color-primary-4 font-16 font-weight-bold flex-grow-1">
        ({{ errors.length }}) Documentos con Error
      </span>
      <div
        class="d-flex align-items-center px-2 rounded-pill border-color--primary-4 cursor-pointer"
        @click="$emit('close')"
      >
        <em class="fa fa-times-circle mr-2 color-primary-4" />
        <span class="color-primary-4 font-16">Cerrar</span>
      </div>
    </div>
    <div v-if="errors.length > 0">
      <div class="scroll-controls">
        <div
          v-if="errors.length > 5"
          class="d-flex flex-column color-primary-4 align-items-end font-20 pr-3 pb-2"
        >
          <em
            class="fa fa-caret-up mb-n1 cursor-pointer"
            @click="onScrolling"
          />
          <em
            class="fa fa-caret-down cursor-pointer"
            @click="onScrolling(false)"
          />
        </div>
      </div>
      <ul class="m-0 pl-4">
        <li
          v-for="(item, index) in errors"
          :key="`error-container-${index}`"
          class="color-primary-4"
        >
          <span class="font-16 font-weight-bold">{{ item.fileName }}</span>
          -
          <span class="font-16">{{ item.description }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileError',
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onScrolling(isScrollingUp = true) {
      const distanceNavigation = 30;
      if (isScrollingUp)
        this.$refs.errorContainer.scrollTop -= distanceNavigation;
      else this.$refs.errorContainer.scrollTop += distanceNavigation;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.error-container {
  border-radius: 5px;
  padding: 10px;
  max-height: 10rem;
  background: map-get($colors, 'pink-1');
  overflow-y: scroll;
  overflow-y: hidden;
  overflow-x: hidden;
}
.scroll-controls {
  position: absolute;
  right: 3rem;
  margin-top: 5rem;
}
</style>
